import { GET_ALLRETAILER_FAILED, GET_ALLRETAILER_LOADING, GET_ALLRETAILER_REMOVE, GET_ALLRETAILER_SUCCESS } from "../types";

const initialState = {
  loading: false,
  error: null,
  Countries: null,
};

export const getAllRetailerReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_ALLRETAILER_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_ALLRETAILER_SUCCESS:
      return {
        ...state,
        loading: false,
        Countries: action.payload,
        error: null,
      };
    case GET_ALLRETAILER_FAILED:
      return {
        ...state,
        loading: false,
        Countries: null,
        error: action.error,
      };
    case GET_ALLRETAILER_REMOVE:
      return initialState;
    default:
      return state;
  }
};
